export class FileUtils {
	static downloadFile(args: { fileName: string; url: string }): void {
		const link = document.createElement('a');
		link.setAttribute('target', '_blank');
		link.setAttribute('href', args.url);
		link.setAttribute('download', args.fileName);
		document.body.appendChild(link);
		link.click();
		link.remove();
	}
}
